var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-1 flex flex-col w-1/2"},[_c('div',{staticClass:"h-full"},[_c('iframe',{attrs:{"id":"htmloutput","srcdoc":_vm.output}})])])}
var staticRenderFns = []

export { render, staticRenderFns }